import Divider from '@mui/material/Divider';
import NewsEditorWidget from '../modules/news/components/NewsEditorWidget';
import WebsiteProjectsWidget from '../modules/website/components/WebsiteProjectsWidget';

export default function AdminDataManagement() {
  return (
    <>
      <WebsiteProjectsWidget />
      <Divider />
      <NewsEditorWidget />
    </>
  );
}
